import type {
  PatientCreatedMatchMethod,
  PatientLinkedMatchMethod,
} from '../../../contracts';

/**
 * Derive `patient_created.match_method` from the input + result state at
 * commit time. The combobox's create CTA renders in three different
 * contexts and we want them distinguishable in the funnel:
 *
 *  - `create_without_search`     — typed nothing, hit Enter / clicked Create
 *  - `create_after_zero_results` — typed something, BE found nothing
 *  - `create_after_search_results` — typed something, BE found rows, picked Create anyway
 */
export function computeCreateMatchMethod(
  trimmedQueryLength: number,
  resultCount: number
): PatientCreatedMatchMethod {
  if (trimmedQueryLength === 0) return 'create_without_search';
  if (resultCount === 0) return 'create_after_zero_results';
  return 'create_after_search_results';
}

/**
 * Derive `patient_linked.match_method` from the last input modality and
 * whether the chosen row was the auto-link candidate. Click always wins —
 * even on the auto-link row — because the user expressed an intent rather
 * than letting cmdk's keyboard default fire.
 */
export function computeLinkMatchMethod(
  wasClick: boolean,
  isAutoLinkCandidate: boolean
): PatientLinkedMatchMethod {
  if (wasClick) return 'explicit_click';
  if (isAutoLinkCandidate) return 'highlighted_default';
  return 'typed_then_picked';
}
